export default __webpack_public_path__ + "static/image_coming_soon-306dd82b4507fba4bbdd4f3ef5917ec3.png";